import $ from 'jquery'
import { Snap as InteractionSnap } from 'ol/interaction'
import Collection from 'ol/Collection'
import { createInvisibleVectorLayer } from './ol'

/**
 * Snap logic
 *
 * Automatically enabled when draw tools are activated and snap is configured for any layer
 *
 * @constructor
 */
export default class Snap {
  constructor(config) {
    $.extend(this, config)

    this.snapFeatures = new Collection()

    this.map.getInteractions().on('add', this.onInteractionsChange.bind(this))
    this.map
      .getInteractions()
      .on('remove', this.onInteractionsChange.bind(this))

    this.map
      .getLayers()
      .forEach(l =>
        l.on('change:visible', this.onLayerVisibilityChange.bind(this))
      )

    this.snapLayers = this.map
      .getLayers()
      .getArray()
      .filter(
        l =>
          l.get('olga_') &&
          l.get('olga_').metadata &&
          l.get('olga_').metadata.snap
      )
      .map(l => {
        const snapLayer = createInvisibleVectorLayer(l.get('olga_'))
        snapLayer.set('originalRef_', l)
        return snapLayer
      })

    this.updateSnapFeatures()
    this.snapLayers.forEach(l => {
      l.getSource().on('addfeature', e => this.snapFeatureAdded(l, e.feature))
      l.getSource().on('removefeature', e =>
        this.snapFeatureRemoved(l, e.feature)
      )
    })

    this.snapInteraction = new InteractionSnap({
      features: this.snapFeatures
    })

    this.active = false
    this.conditionalToggle()
  }

  snapFeatureAdded(layer, feature) {
    if (layer.get('originalRef_').getVisible()) {
      this.snapFeatures.push(feature)
    }
  }

  snapFeatureRemoved(layer, feature) {
    this.snapFeatures.remove(feature)
  }

  updateSnapFeatures() {
    this.snapFeatures.clear()
    this.snapLayers
      .filter(l => l.get('originalRef_').getVisible())
      .map(l => l.getSource())
      .forEach(s => {
        s.getFeatures().forEach(this.snapFeatures.push.bind(this.snapFeatures))
      })
  }

  onLayerVisibilityChange(e) {
    const layer = e.target
    const config = layer.get('olga_')
    if (config.metadata && config.metadata.snap) {
      this.updateSnapFeatures()
    }
  }

  conditionalToggle() {
    if (this.toolbar.activeTool && this.toolbar.activeTool.useSnap) {
      this.activate()
    } else {
      this.deactivate()
    }
  }

  deactivate() {
    if (this.active) {
      this.active = false

      this.snapLayers.forEach(this.map.removeLayer.bind(this.map))
      this.map.removeInteraction(this.snapInteraction)
    }
  }

  activate() {
    if (this.active) {
      return
    }
    this.active = true

    this.snapLayers.forEach(this.map.addLayer.bind(this.map))
    this.map.addInteraction(this.snapInteraction)
  }

  onInteractionsChange(e) {
    if (e.element !== this.snapInteraction) {
      this.conditionalToggle()
    }
  }
}
